import Main from './Main'
import Lista from './components/AvariaLista'
import Novo from './components/NovaAvaria'

export default [
  {
    path: 'avaria',
    name: 'policiacivil.veiculo.avaria',
    component: Main,
    redirect: { name: 'policiacivil.veiculo.avaria.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.veiculo.avaria.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.veiculo.avaria.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.veiculo.avaria.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/veiculo/avaria/routes.js